import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { ShiftsRow } from "../models/Shifts";

export interface GetShiftsParams {
	start: string;
	end: string;
	signal?: AbortSignal;
}

export const getShiftsData = async ({
	start,
	end,
	signal,
}: GetShiftsParams): Promise<ShiftsRow[]> => {
	const apiService = new MESApiService();
	// Plain dates, no time: both sides file billets and stops under a production
	// date rather than a timestamp.
	const parameters: spParameter[] = [
		{ name: "start", value: start },
		{ name: "end", value: end },
	];

	const resp = await apiService.callV2(
		"[MILL].[GetShiftsProductionDataWeb]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching shifts data");
	}
	return get(resp, "data.tables[0].rows", []) as ShiftsRow[];
};
